<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
  <app-input-template
    [inputData]="attributeConstant.username"
    [formControlName]="attributeConstant.username.key">
  </app-input-template>
  <app-input-password
    [inputData]="attributeConstant.password"
    [formControlName]="attributeConstant.password.key">
  </app-input-password>

  <div class="mt-2 mb-3 text-xs text-gray-600 leading-5">
    <label class="flex items-start gap-2 cursor-pointer">
      <input type="checkbox" formControlName="termsAccepted" class="mt-1" />
      <span>
        By continuing to log in, you acknowledge that you have read and agree to
        the
        <a
          class="text-primary hover:underline"
          href="https://writemed.ai/terms-of-service/"
          target="_blank"
          rel="noopener noreferrer"
          >WriteMed.AI Terms of Service</a
        >.
      </span>
    </label>
    @if (loginForm.get('termsAccepted')?.touched && loginForm.get('termsAccepted')?.invalid) {
      <p class="mt-1 text-red-500">Please accept the Terms of Service to continue.</p>
    }
  </div>

  @if (wrongPassword) {
    <!-- <div class="mb-4">
      <a
        (click)="forgotPassword()"
        class="text-center text-sm text-red-400 hover:text-blue-400 cursor-pointer hover:underline">
        * Forgot Password
      </a>
    </div> -->
  }
  <button type="submit" class="first-btn fill-primary">
    <div class="flex justify-center items-center gap-x-3 flex-1">
      <span class="text-lg">{{ 'Log In' }}</span>
      <svg width="17" height="17">
        <path
          d="M8.5.5a8 8 0 1 1 0 16 8 8 0 0 1 0-16ZM5.3 9.42h3.681L7.427 10.9a.92.92 0 1 0 1.27 1.333l3.812-3.627a.147.147 0 0 0 0-.212L8.697 4.767A.92.92 0 1 0 7.427 6.1l1.554 1.478h-3.68a.92.92 0 1 0 0 1.842Z" />
      </svg>
    </div>
  </button>
</form>
